import { Agencies } from "./agencies";

export class BiensImmobs{
    id: number
    name:string;
    description:string;
    agencyName: Agencies[];
    prix:number;
    imageUrl:string;
    status:string;
    categorie:string;
    categoryList:string[];
    promoTitle:string;
    promoImg:string;
    type:string;
    role:string
    videoUrlBien:string;
    nomCommercial:string
    numCommercial:string
    emailCommercial:string

}